<template>
  <div class="game-menu-component">
    <section class="game-menu-section">
      <router-link :to="homeLink" class="section-item" :class="{ active: isHomeRoute }" @click="closeMenu">
        <VdIcon store="fas" name="house" size="large" />
        <!-- <vd-custom-icon name="home-icon" has-hover-state has-hover-with-parent :active="isHomeRoute" /> -->
        <div>Home</div>
      </router-link>
    </section>

    <section
      v-if="canReadAbtests || canReadConfigurations || canReadTesters || canReadSandboxes"
      class="game-menu-section"
    >
      <VdTooltip :content="disabledTestActSectionTooltipContent" :disabled="!disableTestActSection">
        <h6 class="section-title">Test & Act</h6>

        <component
          :is="disableTestActSection ? 'div' : 'router-link'"
          v-if="canReadAbtests"
          :to="abtestsLink"
          class="section-item"
          :class="{ active: isABTestRoute, disabled: disableTestActSection }"
          @click="closeMenu"
        >
          <VdIcon store="fa" name="split" size="large" />
          <!-- <vd-custom-icon
            name="ab-tests-icon"
            :has-hover-state="!disableTestActSection"
            has-hover-with-parent
            :active="isABTestRoute"
            :disabled="disableTestActSection"
          /> -->
          <div>A/B Tests</div>
        </component>

        <router-link
          :to="offersAndStoreLink"
          class="section-item"
          :class="{ active: isOffersAndStoreRoute }"
          @click="closeMenu"
        >
          <VdIcon store="fa" name="tags" size="large" />
          <div>Monetization</div>
          <div class="doc-anchor">
            <VdTooltip content="Documentation: Monetization">
              <span
                class="doc-btn"
                @click.stop.prevent="
                  openUrl('https://app.notion.com/p/voodoo/Monetization-37fa0b481db4809fb3e5e57c5b6ff1f2')
                "
              >
                <VdIcon store="fa" name="circle-question" size="large" />
              </span>
            </VdTooltip>
          </div>
        </router-link>

        <component
          :is="disableTestActSection ? 'div' : 'router-link'"
          v-if="canReadConfigurations"
          :to="configurationsLink"
          class="section-item"
          :class="{ active: isConfigurationRoute, disabled: disableTestActSection }"
          @click="closeMenu"
        >
          <VdIcon store="fa" name="sliders" size="large" />
          <!-- <vd-custom-icon
            name="configuration-icon"
            :has-hover-state="!disableTestActSection"
            has-hover-with-parent
            :active="isConfigurationRoute"
            :disabled="disableTestActSection"
          /> -->
          <div>Remote Configs</div>
        </component>

        <component
          :is="disableTestActSection ? 'div' : 'router-link'"
          v-if="canReadConfigurations"
          :to="simulatorLink"
          class="section-item"
          :class="{ active: isSimulatorRoute, disabled: disableTestActSection }"
          @click="closeMenu"
        >
          <VdIcon store="fa" name="bug" size="large" />
          <!-- <vd-custom-icon
            name="configuration-icon"
            :has-hover-state="!disableTestActSection"
            has-hover-with-parent
            :active="isConfigurationRoute"
            :disabled="disableTestActSection"
          /> -->
          <div>Simulator</div>
        </component>

        <component
          :is="disableTestActSection ? 'div' : 'router-link'"
          v-if="canReadAbtests"
          :to="userInspectorLink"
          class="section-item"
          :class="{ active: isUserInspectorRoute, disabled: disableTestActSection }"
          @click="closeMenu"
        >
          <VdIcon store="fa" name="magnifying-glass" size="large" />
          <div>User Inspector</div>
        </component>

        <component
          :is="disableTestActSection ? 'div' : 'router-link'"
          v-if="canReadTesters"
          :to="testDevicesLink"
          class="section-item"
          :class="{ active: isTestDeviceRoute, disabled: disableTestActSection }"
          @click="closeMenu"
        >
          <VdIcon store="fa" name="address-book" size="large" />
          <!-- <vd-custom-icon
            name="testers-icon"
            :has-hover-state="!disableTestActSection"
            has-hover-with-parent
            :active="isTestDeviceRoute"
            :disabled="disableTestActSection"
          /> -->
          <div>Devices</div>
          <div class="doc-anchor">
            <VdTooltip content="Documentation: Devices">
              <span
                class="doc-btn"
                @click.stop.prevent="
                  openUrl('https://app.notion.com/p/voodoo/Device-Management-112a0b481db480738dd4c6430aa90cef')
                "
              >
                <VdIcon store="fa" name="circle-question" size="large" />
              </span>
            </VdTooltip>
          </div>
        </component>
      </VdTooltip>
    </section>

    <section v-if="canReadClasses || canReadSegments || canReadFeatures" class="game-menu-section">
      <h6 class="section-title">Setup</h6>

      <router-link
        v-if="canReadClasses"
        :to="classesLink"
        class="section-item"
        :class="{ active: isClassRoute }"
        @click="closeMenu"
      >
        <VdIcon store="fa" name="rectangle-code" size="large" />
        <!-- <vd-custom-icon name="classes-icon" has-hover-state has-hover-with-parent :active="isClassRoute" /> -->
        <div>Classes</div>
      </router-link>
      <router-link
        v-if="canReadSegments"
        :to="segmentsLink"
        class="section-item"
        :class="{ active: isSegmentRoute }"
        @click="closeMenu"
      >
        <VdIcon store="fa" name="bullseye-arrow" size="large" />
        <!-- <vd-custom-icon name="audiences-icon" has-hover-state has-hover-with-parent :active="isSegmentRoute" /> -->
        <div>Segments</div>
      </router-link>
      <router-link
        v-if="canReadFeatures"
        :to="featuresLink"
        class="section-item"
        :class="{ active: isFeatureRoute }"
        @click="closeMenu"
      >
        <VdIcon store="fa" name="key-skeleton-left-right" size="large" />
        <!-- <vd-custom-icon name="features-icon" has-hover-state has-hover-with-parent :active="isFeatureRoute" /> -->
        <div>Metrics</div>
      </router-link>
      <router-link :to="iapLink" class="section-item" :class="{ active: isIAPRoute }" @click="closeMenu">
        <VdIcon store="fa" name="coin" size="large" />
        <div>IAP</div>
      </router-link>
    </section>

    <section v-if="canReadActionlogs" class="game-menu-section">
      <h6 class="section-title">Info</h6>

      <router-link
        v-if="canReadActionlogs"
        :to="actionLogsLink"
        class="section-item"
        :class="{ active: isActionLogRoute }"
        @click="closeMenu"
      >
        <VdIcon store="fa" name="file-lines" size="large" />
        <!-- <vd-custom-icon name="action-logs-icon" has-hover-state has-hover-with-parent :active="isActionLogRoute" /> -->
        <div>Action logs</div>
      </router-link>
    </section>
  </div>
</template>

<script lang="ts" setup>
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import { VdTooltip } from "@voodoo.io/voodoo-ui";
import { computed } from "vue";
import { useRoute } from "vue-router";
import usePermissions from "@/hooks/use-permissions";
import links from "@/router/links";

defineProps({
  disableTestActSection: {
    type: Boolean,
  },
});

const emit = defineEmits(["close"]);

const route = useRoute();

const {
  canReadSegments,
  canReadConfigurations,
  canReadAbtests,
  canReadFeatures,
  canReadClasses,
  canReadTesters,
  canReadSandboxes,
  canReadActionlogs,
} = usePermissions();

const isRouteFor = (scope: string) => !!route.matched.find(({ path }) => path === `/games/:gameId/:versionId/${scope}`);

const homeLink = { name: links.games.home };
const isHomeRoute = computed(() => isRouteFor(""));

const classesLink = { name: links.games.classes.list };
const isClassRoute = computed(() => isRouteFor("classes"));

const featuresLink = { name: links.games.features.list };
const isFeatureRoute = computed(() => isRouteFor("features"));

const testDevicesLink = { name: links.games.testDevices.list };
const isTestDeviceRoute = computed(() => isRouteFor("test-devices"));

const segmentsLink = { name: links.games.segments.list };
const isSegmentRoute = computed(() => isRouteFor("segments"));

const configurationsLink = { name: links.games.configurations.list };
const isConfigurationRoute = computed(() => isRouteFor("configurations"));

const abtestsLink = { name: links.games.abtests.list };
const isABTestRoute = computed(() => isRouteFor("abtests"));

const actionLogsLink = { name: links.games.actionLogs };
const isActionLogRoute = computed(() => isRouteFor("action-logs"));

const simulatorLink = { name: links.games.simulator };
const isSimulatorRoute = computed(() => isRouteFor("simulator"));

const userInspectorLink = { name: links.games.userInspector };
const isUserInspectorRoute = computed(() => isRouteFor("user-inspector"));

const iapLink = { name: links.iap.iapList };
const isIAPRoute = computed(() => isRouteFor("iap"));

const offersAndStoreLink = { name: links.offersAndStore.tabs.items };
const isOffersAndStoreRoute = computed(() => isRouteFor("offersAndStore"));

const closeMenu = () => {
  emit("close");
};

const openUrl = (url: string) => {
  window.open(url, "_blank");
};

const disabledTestActSectionTooltipContent = "Add some class to access this content";
</script>

<style lang="scss" scoped>
.game-menu-component {
  @include medium-screen {
    padding: size("ML");
  }

  .game-menu-button {
    display: block;
    position: absolute;
    border-radius: 50%;
    background: $white;
  }

  .game-menu-section {
    display: inline-block;
    font-size: font("M");
    line-height: 1.5;
    letter-spacing: normal;
    color: var(--voodootune-text-color);
    margin: size("XS");
    margin-bottom: size("L");
    width: 100%;
    box-sizing: border-box;
    padding-right: 20px;

    @include medium-screen {
      margin-bottom: 10px;
    }

    .section-title {
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: var(--voodootune-accent-color);
      margin: size("M") 0;
    }

    .section-item {
      display: grid;
      grid-template-columns: size("ML") 1fr;
      position: relative;
      align-items: center;
      padding: size("S") size("S") size("S") 15px;

      &.active {
        background-color: $cloudy-blue;
        border-radius: 5px;
        color: $soft-black;
      }

      .router-link-active {
        color: $soft-black;
      }

      &:hover > div,
      &:hover > svg {
        color: $intense-blue;
      }

      > svg {
        width: 20px;
      }

      > div {
        display: inline-block;
        margin-left: size("M");
        font-weight: 400;
        font-size: font("M");
        color: var(--voodootune-text-color);
        text-decoration: none;
      }

      &.disabled > div {
        color: var(--vd-base-placeholder-color);
      }

      .doc-anchor {
        position: absolute;
        right: 4px;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.15s;
      }

      &:hover .doc-anchor {
        opacity: 1;
      }

      .doc-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--voodootune-text-color);
        cursor: pointer;

        &:hover {
          color: $intense-blue;
        }
      }
    }
  }
}
</style>
